import React from 'react';

const FooterPreview = ({ pageNumber = 1, reportType }) => {
  // Determine the report type text based on the reportType prop
  const getReportTypeText = () => {
    if (reportType) {
      return reportType.toUpperCase();
    }
    return "SELF REPORT"; // Default fallback
  };

  const isGroupReport = reportType === 'GROUP ASSESSMENT';

  // console.log('isGroupReport', isGroupReport)

  const styles = {
    footer: {
      position: 'absolute',
      bottom: 20,
      left: 20,
      right: 20,
      borderTop: '1px solid #426B88',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      paddingTop: '10px',
      paddingBottom: '10px',
      minHeight: '50px',
      width: "468px",
      margin: "auto",
      boxSizing: 'border-box',
      backgroundColor: '#fff',
      zIndex: 1000
    },
    leftSection: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '2px',
      maxWidth: '500px',
      flex: '1',
    },
    footertitle: {
      fontFamily: 'Helvetica, sans-serif',
      fontWeight: 700,
      fontSize: '8px',
      color: '#5795B2',
      textTransform: 'uppercase',
      margin: '0',
      letterSpacing: 0,
      lineHeight: "12px"
    },
    description: {
      fontFamily: 'Helvetica',
      fontWeight: 400,
      fontStyle: 'Regular',
      fontSize: '8px',
      lineHeight: '12px',
      letterSpacing: '0px',
      color: '#666666',
      margin: '0',
      whiteSpace: "nowrap"
    },
    rightSection: {
      display: 'flex',
      alignItems: 'flex-start',
    },
    pagenumber: {
      fontFamily: 'Helvetica, sans-serif',
      fontWeight: 700,
      fontSize: '8px',
      lineHeight: '10px',
      color: '#666666',
      margin: '0',
      textAlign: 'right',
      letterSpacing: 0,
      whiteSpace: "nowrap"

    },
  };

  return (
    <div style={styles.footer}>
      <div style={styles.leftSection}>
        <p style={styles.footertitle}>{getReportTypeText()}</p>
        <p style={styles.description}>
          © Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformed Leader. All rights reserved.
        </p>
      </div>
      <div style={styles.rightSection}>
        {pageNumber > 0 && <p style={styles.pagenumber}>PAGE {pageNumber || 1}</p> }
      </div>
    </div>
  );
};

export default FooterPreview;
